import { JSXElementConstructor, useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import NetworkService from '../utils/network.service';
import { AppDispatch } from '../redux/Store';
import { useDispatch, useSelector } from 'react-redux';
import { socketService } from '../utils/socket.service';
import { getCurrentUser } from '../features/auth/auth.action';
import { useOktaAuth } from '@okta/okta-react';
import { RootReducerState } from '../redux/Reducers';

const PrivateRoute = props => {
  const dispatch = useDispatch<AppDispatch>();
  const { user, tokenChecked } = useSelector((state: RootReducerState) => state.authReducer);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(true);
  const { authState, oktaAuth } = useOktaAuth();

  useEffect(() => {
    NetworkService.setupInterceptors();
  }, []);

  useEffect(() => {
    const localToken = localStorage.getItem('token');

    if (!authState) return; // Okta is still initializing

    if (authState.accessToken) {
      // Okta
      NetworkService.setupDefaultHeaders(authState.accessToken.accessToken, 'okta');
      localStorage.removeItem('token');
    } else if (localToken) {
      // Local
      NetworkService.setupDefaultHeaders(localToken, 'local');
      oktaAuth.clearStorage();
    }

    dispatch(getCurrentUser({ init: true }));
  }, [dispatch, authState, oktaAuth]);

  useEffect(() => {
    if (!authState || authState.accessToken) return; // Sockets are disabled for Okta for now

    const localToken = localStorage.getItem('token');
    if (localToken) {
      socketService.connectWithAuthToken(localToken);
    } else {
      socketService.disconnect();
    }

    return () => socketService.disconnect();
  }, [authState]);

  useEffect(() => {
    if (!user) return;
    if (tokenChecked) {
      setIsLoading(false);
      setIsAuthenticated(true);
    }
  }, [user]);

  const Component: JSXElementConstructor<any> = props.component;
  if (isLoading) return <></>;

  if (!isAuthenticated) return <Redirect to='/' />;

  return <Route {...props.rest} render={props => <Component {...props} />} />;
};
export default PrivateRoute;
